import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useDealBuilderContext } from '../context/DealBuilderContext';
import { getContactId } from '../lib';
import { DealBuilderFormValues, SelectedContactsSummary } from '../types';

export const useSelectedContactsSummary = (): SelectedContactsSummary => {
  const {
    contacts: { contactsData },
  } = useDealBuilderContext();
  const { control } = useFormContext<DealBuilderFormValues>();
  const ownerPgIds = useWatch({ control, name: 'contacts.ownerPgIds' });
  const accountContactIds = useWatch({ control, name: 'contacts.accountContactIds' });

  return useMemo(() => {
    const selectedIds = new Set([...ownerPgIds, ...accountContactIds]);
    const selected = contactsData.allContacts.filter(c => selectedIds.has(getContactId(c)));
    const totalCount = selected.length;

    const primarySelected = contactsData.primaryContact && selectedIds.has(getContactId(contactsData.primaryContact));
    const mainContact = totalCount === 0 ? null : primarySelected ? contactsData.primaryContact : selected[0];
    const additionalCount = totalCount - (mainContact ? 1 : 0);

    let avatarIndex = 0;
    if (mainContact && !primarySelected) {
      const idx = contactsData.additionalRecipients.findIndex(c => getContactId(c) === getContactId(mainContact));
      avatarIndex = idx !== -1 ? idx + 1 : contactsData.additionalRecipients.length + 1;
    }

    return { mainContact, additionalCount, avatarIndex, selectedContacts: selected };
  }, [contactsData, ownerPgIds, accountContactIds]);
};
